import { render } from "./textbox.vue?vue&type=template&id=7aa4fc04&scoped=true"
import script from "./textbox.vue?vue&type=script&lang=js"
export * from "./textbox.vue?vue&type=script&lang=js"

import "./textbox.vue?vue&type=style&index=0&id=7aa4fc04&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7aa4fc04"

export default script